export { default as GraphTab } from './GraphTab';
export { default as TableTab } from './TableTab';
